import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { RepayPageRoutingModule } from './repay-routing.module';

import { RepayPage } from './repay.page';
import { MasterHeaderModule } from '../../../master-header/master-header.module';
import { MasterFooterModule } from '../../../master-footer/master-footer.module';
import { CustomInputModule } from '../../../common-components/custom-input/custom-input.module';
import { RepayDigitalWalletPageModule } from './repay-digital-wallet/repay-digital-wallet.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    RepayPageRoutingModule,
    MasterHeaderModule,
    MasterFooterModule,
    CustomInputModule,
    RepayDigitalWalletPageModule,
  ],
  declarations: [RepayPage],
})
export class RepayPageModule {
}